import * as icons from './icons';

const createIconConfig = (src, size) => ({
	src,
	sizes: `${size}x${size}`,
	type: 'image/png',
	purpose: 'maskable any',
});

const createManifestConfig = ({ name, shortName, icons, themeColor, backgroundColor = '#ffffff' }) => ({
	name: `${name}`,
	short_name: shortName,
	icons: Object.entries(icons).map(([size, src]) => createIconConfig(src, size)),
	start_url: window.location.origin,
	display: 'fullscreen',
	theme_color: themeColor,
	background_color: backgroundColor,
});

export const manifestConfigs = {
	entekhab: createManifestConfig({
		name: 'Entekhabino app',
		shortName: `Entekhabino`,
		icons: icons.entekhabIcons,
		themeColor: '#5CC67C',
	}),

	darsad: createManifestConfig({
		name: 'Darsad app',
		shortName: `Darsad`,
		icons: icons.darsadIcons,
		themeColor: '#e43024',
	}),

	keepa: createManifestConfig({
		name: 'Keepa app',
		shortName: `Keepa`,
		icons: icons.keepaIcons,
		theme_color: '#35306f',
	}),

	sabalend: createManifestConfig({
		name: 'Sabalend app',
		shortName: `Sabalend`,
		icons: icons.sabalendIcons,
		theme_color: '#106239',
	}),

	refahyar: createManifestConfig({
		name: 'Refahyar app',
		shortName: `Refahyar`,
		icons: icons.refahyarIcons,
		theme_color: '#039',
	}),

	fara: createManifestConfig({
		name: 'Fara app',
		shortName: `Fara`,
		icons: icons.faraIcons,
		theme_color: '#039',
	}),

	hamtaland: createManifestConfig({
		name: 'Hamtaland app',
		shortName: `Hamtaland`,
		icons: icons.hamtalandIcons,
		theme_color: '#ffffff',
	}),

	rayansaipa: createManifestConfig({
		name: 'Rayansaipa app',
		shortName: `Rayansaipa`,
		icons: icons.rayansaipaIcons,
		theme_color: '#ffffff',
	}),

	ghestane: createManifestConfig({
		name: 'Ghestane app',
		shortName: `Ghestane`,
		icons: icons.ghestanehIcons,
		theme_color: '#fa8071',
		background_color: '#fa8071',
	}),

	demo: createManifestConfig({
		name: 'Demo app',
		shortName: `Demo`,
		icons: icons.keepaIcons,
		theme_color: '#35306f',
	}),

	tisa: createManifestConfig({
		name: 'Tisa-pay app',
		shortName: `Tisapay`,
		icons: icons.tisaIcons,
		theme_color: '#3D85C6',
	}),

	saana: createManifestConfig({
		name: 'Saana-pay app',
		shortName: `Saana`,
		icons: icons.saanaIcons,
		theme_color: '#3D85C6',
	}),

	shopp: createManifestConfig({
		name: 'Shopp',
		shortName: `Shopp`,
		icons: icons.shoppIcons,
		theme_color: '#3D85C6',
	}),

	arbaeen: createManifestConfig({
		name: 'Arbaeen-pay app',
		shortName: `ArbaeenPay`,
		icons: icons.arbaeenIcons,
		theme_color: '#3D85C6',
	}),

	danesh: createManifestConfig({
		name: 'Danesh app',
		shortName: `Danesh`,
		icons: icons.daneshIcons,
		theme_color: '#3D85C6',
	}),

	karma: createManifestConfig({
		name: 'Karma',
		shortName: `Karma`,
		icons: icons.karmaIcons,
		theme_color: '#2B3788',
	}),
	hastesh: createManifestConfig({
		name: 'Hastesh-pay app',
		shortName: `Hasteshpay`,
		icons: icons.hasteshIcons,
		theme_color: '#a82682',
	}),

	armanpay: createManifestConfig({
		name: 'Arman app',
		shortName: `Arman-pay`,
		icons: icons.armanpayIcons,
		theme_color: '#ffff',
	}),

	calko: createManifestConfig({
		name: 'KALKOO',
		shortName: `KALKOO`,
		icons: icons.calkoIcons,
		theme_color: '#ffff',
	}),

	lendavid: createManifestConfig({
		name: 'Lendavid app',
		shortName: `Lendavid`,
		icons: icons.lendavidIcons,
		theme_color: '#F2F2CF',
	}),
	flyToday: createManifestConfig({
		name: 'flytoday app',
		shortName: `FlyToday`,
		icons: icons.flyTodayIcons,
		theme_color: '#fff',
	}),
	can: createManifestConfig({
		name: 'Can app',
		shortName: `CanPay`,
		icons: icons.canIcons,
		theme_color: '#fff',
	}),
};
